import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Modal } from "react-bootstrap";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Switch from '@mui/material/Switch';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import * as Icons from '@mui/icons-material';
import Accordion from 'react-bootstrap/Accordion';
import CreateData from './CreateData';
import { changeHomeTab, createTemplate, getProfileData, createDatatype, createPurpose, getEntityList, getPurpose, getDatatype, createConsentGroup, update_Consent_Group, getConsentGroupData, clearSession } from '../store/actions/CommonAction'
import CreatePurpose from './CreatePurpose';
import { ToastContainer, toast } from 'react-toastify';
import AddNewMaterialIcon from '@material-ui/icons/AddCircle';
import session from 'redux-persist/lib/storage/session';


let array = [];

const CreateConsentgroup = () => {

    const getSelectedCGE = useSelector(state => state.common.selectedCGE);
    console.log("getSelectedCGE through common action-->" + JSON.stringify(getSelectedCGE));
    const entityList = useSelector(state => state.common.entityList)
    const appName = useSelector(state => state.common.App_Name)
    const getDatatypeList = useSelector(state => state.common.getDatatypeList)
    const consentGroups = useSelector(state => state.common.getConsentGroupData);


    const history = useHistory();
    const dispatch = useDispatch()
    const { page } = useParams();

    const [accordionItems, setAccordionItems] = useState([0]);
    const [option, setOption] = useState([]);
    const [showConsumerToggle, setShowConsumerToggle] = useState(false);
    const [initialArray, setInitialArray] = useState([]);
    const [entityListDraft, setEntityListDraft] = useState([]);
    const [showDataTypeModal, setShowDataTypeModal] = useState(false);
    const [openCreateDataType, setOpenCreateDataType] = useState(false);
    const [openCreatePurpose, setOpenCreatePurpose] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [formDataArray, setFormDataArray] = useState([]);

    const [indexVal, setIndexVal] = useState([]);

    console.log(consentGroups);

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const [values, setValues] = useState({
        select1: '',
    });

    const addAccordionItem = () => {
        const newItemKey = accordionItems.length;
        setAccordionItems([...accordionItems, newItemKey]);
    };

    const deleteAccordionItem = (itemKey) => {
        console.log(itemKey)
        const newItemKey = accordionItems.length;
        const updatedAccordionItems = accordionItems.filter(index => index !== itemKey);
        setAccordionItems(updatedAccordionItems);
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setValues({
            ...values,
            [name]: value,
        });
    };

    const collectAllFormData = () => {
        // Create an array to store form data from all accordion items
        // alert("accordionItems : "+accordionItems);
        //console.log("formDataArray : "+JSON.stringify(formDataArray));
        const allFormData = accordionItems.map((itemKey) => formDataArray[itemKey]);


        if (allFormData !== null) {
            //alert("allFormData ----- : " + JSON.stringify(allFormData));
            return allFormData;
        } else {
            toast.error("Please fill the template form before Saving!")
        }

        // console.log("allFormData : "+JSON.stringify(allFormData));
        // return allFormData;
    };

    const handleCollectAllFormData = async () => {
        const allFormData = collectAllFormData();

        // Do something with the collected data (e.g., alert or API call)
        //alert("allFormData : -->" + JSON.stringify(allFormData));


        if (allFormData == "") {
            await toast("Please fill the template form before proceeding!");
        } else {

            var consentGroupName = document.getElementById("consentGroupName").value;

            // Check for Duplicate Consent Group Name
            if (consentGroups !== "") {
                const existingGroup = consentGroups.find(group => group.consentGroupName === consentGroupName);
                if (existingGroup && existingGroup.status !== 'DRAFT') {
                    await toast("Consent Group Name should be unique");
                    return;
                }
                // Allow Update Only for Draft Status
                if (existingGroup && existingGroup.status !== 'DRAFT') {
                    await toast("Cannot update Consent Group with status other than 'draft'");
                    return;
                }
            }


            var consentGroupName = document.getElementById("consentGroupName").value;
            if (getSelectedCGE.length > 0) {
                var groupID = getSelectedCGE[0].consentGroupId;
            }


            // Exclude the current group being edited during duplicate check
            if (consentGroups !== "") {
                const isDuplicate = consentGroups.some(group =>
                    group.consentGroupName === consentGroupName && group.consentGroupId !== groupID
                );

                if (isDuplicate) {
                    await toast("Consent Group Name should be unique");
                    return;
                }
            }
            //alert("consentGroupName : "+consentGroupName);
            //alert(groupID);
            if (consentGroupName === "" || consentGroupName.trim() === '') {
                await toast("Please fill the Consent Group Name before proceeding!");
                return;
            }

            // for (var i = 0; i < allFormData.length; i++) {
            //     var eachData = allFormData[i];
            for (var i = 0; i < allFormData.length; i++) {
                var eachData = allFormData[i];
                // alert("eachData : "+eachData.consentValidity.value < 99);

                if (eachData != undefined) {

                    // Validate consentValidity
                    if (eachData.consentValidity === undefined || eachData.consentValidity.value > 99 || eachData.consentValidity.value < 1) {
                        await toast("Consent Validity must be between 1 and 99 in Template #" + (i + 1) + "!");
                        return;  // Stop further execution if validation fails
                    }

                    if (!eachData.dataTypes || eachData.dataTypes.length == 0) {
                        // alert("asd");
                        // let t1 = eachData.itemKey || 'unknownn template'
                        console.log(JSON.stringify(eachData) + 'eachdata');
                        //await toast("Please fill the dataTypes before proceeding in Template #"+(i+1)+" !");
                        await toast("Please fill the dataTypes before proceeding in Template #" + (i + 1) + "!");

                        return;
                    }
                    else if (eachData.nickName === "" || eachData.nickName.trim() === '') {
                        await toast("Please fill the DataSet Name before proceeding in Template #" + (i + 1) + "!");
                        return;
                    }
                    else if (!eachData.purpose || eachData.purpose.length == 0) {
                        await toast("Please fill the purpose before proceeding in Template #" + (i + 1) + "!");
                        return;
                    }
                    // else if (eachData.consentValidity.value > 99) {
                    //     await toast("Consent Validity must be between 1 and 99 in Template #" + (i + 1) + "!");
                    //     return;
                    // }
                    else if ((!eachData.dataConsumer || eachData.dataConsumer.length === 0) && page !== "draft") {
                        // alert("data consumer not present"+JSON.stringify(eachData));
                        if (eachData.shared) {
                            await toast("Please fill the Data Consumer before proceeding with the help of selecting To Be Shared? option in Template #" + (i + 1) + "!");
                            return;
                        } else {
                            //alert("eachData.dataProvider : "+eachData.dataProvider);
                            var dataConsumerArr = [eachData.dataProvider]
                            eachData.dataConsumer = dataConsumerArr;
                        }

                    } else if ((!eachData.dataConsumer || eachData.dataConsumer.length === 0) && page == "draft") {
                        // alert("data consumer not present"+JSON.stringify(eachData));

                        for (var eachSelectedData of getSelectedCGE) {

                            if (eachSelectedData.nickName == eachData.nickName && eachData.shared && (!eachSelectedData.dataConsumer || eachSelectedData.dataConsumer.length === 0)) {
                                await toast("Please fill the Data Consumer before proceeding with the help of selecting To Be Shared? optionin Template #" + (i + 1) + "!");
                                return;
                            } else {
                                //alert("eachData.dataProvider : "+eachData.dataProvider);
                                //var dataConsumerArr = [eachData.dataProvider]
                                eachData.dataConsumer = eachSelectedData.dataConsumer;
                            }

                        }
                    }

                } else {
                    await toast("Please fill the template #" + (i + 1) + " form before proceeding!");
                    return;
                }



            }

            // Check if the target URL includes '/createConsentGroup/draft'
            const skipUniquenessCheck = window.location.pathname.includes(`/createConsentGroup/${encodeURIComponent('draft')}`);
            // Skip uniqueness check if the condition is true
            if (!skipUniquenessCheck && consentGroups != "") {
                const isConsentGroupNameUnique = !consentGroups.some(
                    (group) => group.consentGroupName === consentGroupName
                );

                if (!isConsentGroupNameUnique) {
                    await toast("Consent Group Name must be unique");
                    return;
                }
            }

            console.log("allFormData : +++++++" + JSON.stringify(allFormData));

            var request = {
                "consentGroupName": consentGroupName,
                "templates": allFormData
            }
            //alert("GROUP ID-->"+selectedConsentGroupid)
            //alert("request in update " + JSON.stringify(request));
            var targetUrl = window.location.pathname;
            if (targetUrl === `/createConsentGroup/${encodeURIComponent('draft')}` && consentGroupName !== "") {
                await dispatch(update_Consent_Group(request, groupID));

                //alert("Tagrget URL in if means existing updated--> : "+targetUrl);
                await toast("Consent Group Updated Successfully");
                history.push('/consentgroup')

            } else {
                console.log("request in else " + JSON.stringify(request));
                await dispatch(createConsentGroup(request));

                //alert("Tagrget URL in else means new consent created-->"+ targetUrl);

                // alert("response : "+JSON.stringify(getCreateConsentGroupResponse));
                //alert("Consent Group Created Successfully")
                if (consentGroupName)
                    await toast("Consent Group Created Successfully");
                history.push('/consentgroup')
            }
        }
    };

    // const fillFromDraft = () => {
    //     // alert("getSelectedCGE ..."+JSON.stringify(getSelectedCGE));
    //     var numberofTemplates = getSelectedCGE.length;
    //      alert("numberofTemplates ..."+numberofTemplates);
    //     for (var i = 0; i < numberofTemplates; i++) {
    //         alert(i);
    //         addAccordionItem();
    //     }
    // }

    const fillFromDraft = () => {
        var numberofTemplates = getSelectedCGE.length;
        // Create an array with the desired number of items
        const items = Array.from({ length: numberofTemplates }, (_, index) => index);
        // Update the state once with the full array
        setAccordionItems(items);
    };


    useEffect(() => {

        if (!sessionStorage.getItem('sessionId')) {
            toast.error(`Your Session has Expired: Please login again`);
            window.location.href = '/login';
        }


        // alert("page :"+page);
        if (page == "draft") {
            fillFromDraft();
        }

    }, [])


    return (
        <>
            <section className='content-header'>
                <div className='container' style={{ marginTop: '6%' }}>
                    <div className='row align-items-center'>
                        <div className='col-md-6'>
                            <h1 className='page-title'>
                                Create Consent Group
                            </h1>
                        </div>
                        <div className='col-md-6'>
                            <div className='row'>
                                <div className='col-md-6 offset-md-1 my-3 my-md-0'>
                                    <TextField fullWidth label="Enter Group Name" variant="standard" size='small' id="consentGroupName" name='consentGroupName' required />
                                </div>
                                <div className='col-md-5'>
                                    {/* <button className='btn btn-outline-primary btn-lg btn-r25 px-3'>
                    <svg
                      width='17'
                      height='16'
                      viewBox='0 0 17 16'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M8.02667 11.14C8.08864 11.2025 8.16238 11.2521 8.24362 11.2859C8.32486 11.3198 8.41199 11.3372 8.5 11.3372C8.58801 11.3372 8.67515 11.3198 8.75638 11.2859C8.83762 11.2521 8.91136 11.2025 8.97333 11.14L10.9733 9.14001C11.0989 9.01447 11.1694 8.84421 11.1694 8.66668C11.1694 8.48914 11.0989 8.31888 10.9733 8.19334C10.8478 8.06781 10.6775 7.99728 10.5 7.99728C10.3225 7.99728 10.1522 8.06781 10.0267 8.19334L9.16667 9.06001V2.00001C9.16667 1.8232 9.09643 1.65363 8.9714 1.52861C8.84638 1.40358 8.67681 1.33334 8.5 1.33334C8.32319 1.33334 8.15362 1.40358 8.0286 1.52861C7.90357 1.65363 7.83333 1.8232 7.83333 2.00001V9.06001L6.97333 8.19334C6.8478 8.06781 6.67753 7.99728 6.5 7.99728C6.32247 7.99728 6.1522 8.06781 6.02667 8.19334C5.90113 8.31888 5.83061 8.48914 5.83061 8.66668C5.83061 8.84421 5.90113 9.01447 6.02667 9.14001L8.02667 11.14ZM13.8333 8.00001C13.6565 8.00001 13.487 8.07025 13.3619 8.19527C13.2369 8.3203 13.1667 8.48987 13.1667 8.66668V12.6667C13.1667 12.8435 13.0964 13.0131 12.9714 13.1381C12.8464 13.2631 12.6768 13.3333 12.5 13.3333H4.5C4.32319 13.3333 4.15362 13.2631 4.0286 13.1381C3.90357 13.0131 3.83333 12.8435 3.83333 12.6667V8.66668C3.83333 8.48987 3.7631 8.3203 3.63807 8.19527C3.51305 8.07025 3.34348 8.00001 3.16667 8.00001C2.98986 8.00001 2.82029 8.07025 2.69526 8.19527C2.57024 8.3203 2.5 8.48987 2.5 8.66668V12.6667C2.5 13.1971 2.71071 13.7058 3.08579 14.0809C3.46086 14.456 3.96957 14.6667 4.5 14.6667H12.5C13.0304 14.6667 13.5391 14.456 13.9142 14.0809C14.2893 13.7058 14.5 13.1971 14.5 12.6667V8.66668C14.5 8.48987 14.4298 8.3203 14.3047 8.19527C14.1797 8.07025 14.0101 8.00001 13.8333 8.00001Z'
                        fill='#0A2885'
                      />
                    </svg>
                    Download Report
                  </button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='content h-100'>
                <div className='container' style={{ marginTop: '3%' }}>
                    <div className='row'>
                        <div className='col-md-12'>
                            <Accordion defaultActiveKey="0" className='custom-accordion'>
                                {accordionItems.map((itemKey, index) => (
                                    <Accordion.Item className='br20 mb-3' key={itemKey} eventKey={itemKey.toString()}>
                                        <Accordion.Header className='hbr20'>
                                            Template # {index + 1}
                                            {accordionItems.length > 1 && <div className='ah-buttons iconDelete' >
                                                <IconButton aria-label="delete" size="small" className='text-danger mx-1' onClick={() => deleteAccordionItem(itemKey)} style={{ float: 'right' }}>
                                                    <Icons.Delete fontSize="small" />
                                                </IconButton>
                                            </div>}
                                        </Accordion.Header>

                                        <Accordion.Body>
                                            <FormComponent itemKey={itemKey}
                                                initialValues={getSelectedCGE ? ((getSelectedCGE[itemKey]) ? (getSelectedCGE[itemKey] || {}) : "") : ""}
                                                onCollectFormData={(formData) => {
                                                    // Add the formData to the formDataArray
                                                    setFormDataArray((prevDataArray) => {
                                                        // alert("prevDataArray :"+JSON.stringify(prevDataArray))
                                                        const newData = [...prevDataArray];
                                                        newData[itemKey] = formData;
                                                        return newData;
                                                    });
                                                }}
                                            />
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))}
                            </Accordion>
                        </div>
                    </div>
                </div>
            </section>

            <div style={{ marginRight: '60px', paddingBottom: '5%' }}>
                <section>
                    <div className='row mt-4'>
                        <div className='col-md-12 text-end'>
                            <button className='btn btn-outline-primary btn-r25 px-3 me-sm-3 mb-3 mb-sm-0' onClick={handleCollectAllFormData}>
                                <Icons.Save />
                                Save as Draft
                            </button>
                            <button className='btn btn-primary btn-r25 px-3' onClick={addAccordionItem} style={{ width: 'fit-content' }}>
                                <Icons.Add />
                                New Template
                            </button>
                        </div>
                    </div>
                </section>
            </div>
            <CreateData
                open={openCreateDataType}
                onClose={() => setOpenCreateDataType(false)}
            />

            <CreatePurpose
                open={openCreatePurpose}
                onClose={() => setOpenCreatePurpose(false)}
            />
        </>
    );
}

function FormComponent({ itemKey, initialValues, onCollectFormData }) {

    const appName = useSelector(state => state.common.App_Name)
    const getDatatypeList = useSelector(state => state.common.getDatatypeList)
    const getPurposeList = useSelector(state => state.common.getPurposeList)
    const entityList = useSelector(state => state.common.entityList)
    const clientId = useSelector(state => state.common.clientId)

    const [isChecked, setIsChecked] = useState(false);
    const [accordionItems, setAccordionItems] = useState([0]);
    const [openCreateDataType, setOpenCreateDataType] = useState(false);
    const [openCreatePurpose, setOpenCreatePurpose] = useState(false);
    const [option, setOption] = useState([]);
    const [showConsumerToggle, setShowConsumerToggle] = useState(false);
    const [entityListDraft, setEntityListDraft] = useState([]);
    const [showAddConsumer, setShowAddConsumer] = useState(false);
    const [ConsumerName, setConsumerName] = useState('');



    const showAddConsumerModal = () => {
        //alert("helo");
        setShowAddConsumer(!showAddConsumer)

    }
    const closeAddConsumerModal = () => {
        setShowAddConsumer(!showAddConsumer)

    }

    const dispatch = useDispatch()
    const { page } = useParams();

    const [values, setValues] = useState({
        select1: '',
    });

    useEffect(() => {
        async function fetchData() {
            try {
                await dispatch(getConsentGroupData(clientId));
            } catch (error) {
                console.error(error);
            }
        }

        fetchData();
    }, [dispatch, clientId]);

    const [formData, setFormData] = useState({
        consentMode: 'STORE',
        fetchType: 'PERIODIC',
        consentTypes: [],
        nickName: '',
        // consentTypes: consentTypes ? consentTypes : ["Profile","Usage","Preferences"],
        dataTypes: [],
        dataConsumer: [],
        dataProvider: appName,
        purpose: [],
        // consentCategory: '',
        // userManageable: '',
        consentValidity: { 'unit': 'YEAR', 'value': 1 },
        DataLife: { 'unit': 'YEAR', 'value': 1 },
        Frequency: { 'unit': 'YEAR', 'value': 1 },
        // from: '',
        // to: '',
        shared: false,
        mandatory: false,
        // format:'html along with argument sequence.'
        // format: ''
    });

    const setValuesOfCheckBox = (values, key, count) => {
        //alert("----key :"+values);
        let array = [];
        if (key == "shared" || key == "mandatory") {
            var idVal = key + "_" + count;
            //alert("idVal : "+idVal+"values : "+values);
            var element = document.getElementById(idVal);
            if (element) {
                //alert("element.checked "+element.checked);
                element.checked = values;
            } else {
                console.error(`Element with id ${idVal} not found`);
            }
            if (key === "shared" && values === true) {
                // setShowConsumerToggle(true);
                setIsChecked(true);
                setShowConsumerToggle(true);
            }
        } else {

            for (var val of values) {
                if (key == "consentTypes") {
                    //alert("val : "+val)
                    // var newVal = val.replace(" Data", "");
                    // alert("spliced is "+newVal)
                    var idVal = val + "_" + count;
                    //alert(idVal);
                    // document.getElementById(idVal).checked = true;
                    var element = document.getElementById(idVal);
                    if (element) {
                        //alert(element+"in element")
                        element.checked = true;

                    } else {
                        // alert(`Element with id ${idVal} not found`)
                    }

                    getDatatypeList.forEach((element) => {
                        // alert("got here")
                        if (val === "") {
                            setOption([]);
                            // setuserVal({...userVal, consentTypes: element.consentType, dataTypes: []})
                        }

                        // Clear the array at the beginning of each iteration

                        if (element.dataType === val) {
                            element.consentType.forEach((ele, id) => {
                                array.push(ele);
                            });
                        } else if (element.dataType === val) {
                            element.consentType.forEach((ele, id) => {
                                array = array.filter((elemt) => !(elemt === ele));
                            });
                            // alert("array :" + array);
                        }
                        setOption(array);
                    });


                } else if (key === 'dataTypes') {

                    var idVal = val + "_" + count;
                    if (!initialArray.includes(val)) {
                        initialArray.push(val);
                    }

                } else {
                    var idVal = val + "_" + count;
                    //alert("@#$%^&* + "+idVal);
                    var element = document.getElementById(idVal);
                    if (element) {
                        // Check if the element exists before trying to access its properties
                        element.checked = true;
                    }
                    //document.getElementById(idVal).checked = true;
                }
            }
        }
        return values;
    }

    const saveAddConsumer = () => {

        //alert(ConsumerName);

        if (page == "draft") {
            var val = { "appName": ConsumerName, "clientId": "001" }
            entityListDraft.push(val);
            //setEntityListDraft(entityList);
        } else {
            var val = { "appName": ConsumerName, "clientId": "001" }
            entityList.push(val);
        }

        setShowAddConsumer(!showAddConsumer)

        //alert(JSON.stringify(entityList));
    }

    const [initialArray, setInitialArray] = useState([]);

    const handleInputChange = (e) => {
        //let array = [];

        const { name, value, type, checked } = e.target;
        console.log({ name, value, type, checked });
        // alert("name :"+name+", type: "+type+", value: "+value);
        if (type === 'checkbox') {

            // if (name === 'consentTypes') {

            //     setFormData((prevData) => {
            //         //alert(JSON.stringify(prevData))
            //         const updatedData = {
            //             ...prevData,
            //             consentTypes: checked
            //                 ? [...prevData.consentTypes, value]
            //                 : prevData.consentTypes.filter((item) => item !== value),
            //         };

            //         // Pass the updated state to onCollectFormData
            //         onCollectFormData(updatedData);
            //         return updatedData;
            //     });
            //     //alert("getDatatypeList : "+JSON.stringify(getDatatypeList));
            //     //  alert("checked : "+checked);

            //     getDatatypeList.forEach((element) => {
            //         //alert("got here")
            //         if (value === "") {
            //             setOption([])
            //             //setuserVal({...userVal,consentTypes:element.consentType,dataTypes:[]})      
            //         }
            //         if (element.dataType === value && checked) {

            //             element.consentType.forEach((ele, id) => {
            //                 // array.push(ele);
            //                 if (!array.includes(ele)) {
            //                     array.push(ele);
            //                 }

            //             })

            //         } else if (element.dataType === value && !checked) {

            //             element.consentType.forEach((ele, id) => {
            //                 array = array.filter((elemt) => !(elemt === ele));
            //             })

            //             // alert("array :"+array);

            //         }
            //         setOption(array)

            //     })

            // } else if (name === 'dataTypes') {

            //     setInitialArray((prevArray) => {
            //         if (prevArray.includes(value)) {
            //             return prevArray.filter((elemt) => (elemt !== value));
            //         } else {
            //             return [...prevArray, value];
            //         }
            //     });

            //     setFormData((prevData) => {
            //         const updatedData = {
            //             ...prevData,
            //             dataTypes: checked
            //                 ? [...prevData.dataTypes, value]
            //                 : prevData.dataTypes.filter((item) => item !== value),
            //         };

            //         // Pass the updated state to onCollectFormData
            //         onCollectFormData(updatedData);
            //         return updatedData;
            //     });

            // } 


            if (name === 'consentTypes') {
                setFormData((prevData) => {
                    const updatedData = {
                        ...prevData,
                        consentTypes: checked
                            ? [...prevData.consentTypes, value]
                            : prevData.consentTypes.filter((item) => item !== value),
                    };

                    // Handle the removal of associated data types if a consent type is unchecked
                    if (!checked) {
                        // Find associated data types
                        const associatedDataTypes = getDatatypeList.find(element => element.dataType === value).consentType;

                        // Remove associated data types from initialArray
                        setInitialArray(prevArray =>
                            prevArray.filter(item => !associatedDataTypes.includes(item))
                        );

                        // Remove associated data types from formData
                        updatedData.dataTypes = updatedData.dataTypes.filter(
                            item => !associatedDataTypes.includes(item)
                        );
                    }

                    // Pass the updated state to onCollectFormData
                    onCollectFormData(updatedData);
                    return updatedData;
                });

                // Handle updating the option list
                if (checked) {
                    const newOptions = getDatatypeList
                        .find(element => element.dataType === value)
                        .consentType.filter(item => !array.includes(item));

                    array = [...array, ...newOptions];
                } else {
                    array = array.filter(item => {
                        const consentType = getDatatypeList.find(element => element.dataType === value);
                        return !consentType.consentType.includes(item);
                    });
                }

                setOption(array);
            } else if (name === 'dataTypes') {
                setInitialArray((prevArray) => {
                    if (prevArray.includes(value)) {
                        return prevArray.filter((elemt) => elemt !== value);
                    } else {
                        return [...prevArray, value];
                    }
                });

                setFormData((prevData) => {
                    const updatedData = {
                        ...prevData,
                        dataTypes: checked
                            ? [...prevData.dataTypes, value]
                            : prevData.dataTypes.filter((item) => item !== value),
                    };

                    // Pass the updated state to onCollectFormData
                    onCollectFormData(updatedData);
                    return updatedData;
                });
            }


            else if (name === 'purpose') {

                setFormData((prevData) => {
                    const updatedData = {
                        ...prevData,
                        purpose: checked
                            ? [...prevData.purpose, value]
                            : prevData.purpose.filter((item) => item !== value),
                    };

                    // Pass the updated state to onCollectFormData
                    onCollectFormData(updatedData);

                    return updatedData;
                });

            } else if (name === 'shared') {
                // alert("in shared");
                setIsChecked(e.target.checked);
                // setShowConsumerToggle(event.target.checked);
                setShowConsumerToggle(!showConsumerToggle);

                setFormData((prevData) => {

                    let updatedData = {};

                    if (checked) {
                        updatedData = {
                            ...prevData,
                            shared: checked
                        };
                    } else {
                        updatedData = {
                            ...prevData,
                            shared: checked,
                            dataConsumer: []
                        };
                    }

                    // Pass the updated state to onCollectFormData
                    onCollectFormData(updatedData);



                    //alert("shared : "+checked)

                    return updatedData;
                });

            } else if (name === 'mandatory') {
                //alert("mandatory");
                setFormData((prevData) => {

                    const updatedData = {
                        ...prevData,
                        mandatory: checked
                    };

                    // Pass the updated state to onCollectFormData
                    onCollectFormData(updatedData);

                    return updatedData;
                });

            }




        } else if (type === 'select-multiple') {
            if (name === 'dataConsumer') {

                const selectedOptions = e.target.selectedOptions;
                const selectedValuesArray = Array.from(selectedOptions).map(option => option.value);


                setFormData((prevData) => {

                    const updatedData = {
                        ...prevData,
                        dataConsumer: selectedValuesArray
                    };


                    onCollectFormData(updatedData);

                    return updatedData;
                });
            }
        } else if (type === 'select-one') {

        } else if (type === 'number') {
            //alert("in here"+name);
            if (name === 'consentValidityValue') {

                //var unit = document.getElementById("validityUnit_" + itemKey).value;
                const unit = formData.consentValidity.unit;
                //alert("unit :"+unit);
                let consentValidity = { 'unit': unit, 'value': e.target.value }

                setFormData((prevData) => {

                    const updatedData = {
                        ...prevData,
                        consentValidity: consentValidity
                    };
                    onCollectFormData(updatedData);
                    return updatedData;
                });
            }
        } else if (type === 'radio') {
            if (name === 'consentValidityUnit') {
                var validityValue = document.getElementById("validityValue_" + itemKey).value;
                //alert("unit :"+validityValue);
                let consentValidity = { 'unit': e.target.value, 'value': validityValue }
                //consentValidity.

                setFormData((prevData) => {

                    const updatedData = {
                        ...prevData,
                        consentValidity: consentValidity
                    };
                    onCollectFormData(updatedData);

                    return updatedData;
                });
            }
        }
        else {
            setFormData({
                ...formData,
                [name]: value,
            });
            onCollectFormData(formData);
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setValues({
            ...values,
            [name]: value,
        });
    };

    // const addAccordionItem = () => {
    // const newItemKey = accordionItems.length;
    // setAccordionItems([...accordionItems, newItemKey]);
    // };

    const handleCheckboxChange = (event) => {
        //alert("asd");
        setIsChecked(event.target.checked);
        setShowConsumerToggle(event.target.checked);
    };

    const [userVal, setuserVal] = useState({
        consentMode: 'STORE',
        fetchType: 'PERIODIC',
        consentTypes: [],
        nickName: '',
        dataTypes: '',
        dataConsumer: '',
        dataProvider: '',
        purpose: '',

        consentValidityUnit: 'YEAR',
        consentValidityValue: '1',
        DataLifeUnit: 'YEAR',
        DataLifeValue: '1',
        FrequencyUnit: 'MONTH',
        FrequencyValue: '1',
    });

    const getList = async () => {
        try {
            await dispatch(getEntityList())
            await dispatch(getPurpose())
            await dispatch(getDatatype())
            await dispatch(getProfileData(clientId))

        } catch (e) {
            // console.log(e)
        }
    }

    useEffect(() => {
        getList()
        //console.log('val of format ', JSON.stringify(userVal.format))
        //applyTheme()
        //alert("initialValues : "+JSON.stringify(initialValues));
        if (page == "draft") {
            //alert("initialValues : "+initialValues);
            if (initialValues != "") {
                autoFillForm(initialValues, itemKey);
            }

            setEntityListDraft(entityList);

        }

    }, [userVal.format])

    useEffect(() => {
        const handleUnload = () => {
            // Perform actions before the component unloads
            dispatch(clearSession());
        };
        window.addEventListener("unload", handleUnload);
        return () => {
            window.removeEventListener("unload", handleUnload);
        };
    }, [dispatch]);

    const autoFillForm = (formValues, itemKey) => {

        //alert("formValues : "+JSON.stringify(formValues));

        document.getElementById("consentGroupName").value = formValues.consentGroupName;

        setFormData({
            ...formData,
            consentMode: 'STORE',
            fetchType: 'PERIODIC',
            consentTypes: setValuesOfCheckBox(formValues.consentTypes, 'consentTypes', itemKey),

            nickName: formValues.nickName,
            // consentTypes: consentTypes ? consentTypes : ["Profile","Usage","Preferences"],
            dataTypes: setValuesOfCheckBox(formValues.dataTypes, 'dataTypes', itemKey),
            //dataConsumer: formValues.dataConsumer,
            dataConsumer: setValuesOfSelectedBox(formValues.dataConsumer, 'dataConsumer', itemKey),
            dataProvider: formValues.dataProvider,
            purpose: setValuesOfCheckBox(formValues.purpose, 'purpose', itemKey),
            // consentCategory: '',
            // userManageable: '',
            consentValidity: formValues.consentValidity,
            DataLife: { 'unit': 'YEAR', 'value': 1 },
            Frequency: { 'unit': 'YEAR', 'value': 1 },
            // from: '',
            // to: '',
            shared: setValuesOfCheckBox(formValues.shared, 'shared', itemKey),
            mandatory: setValuesOfCheckBox(formValues.mandatory, 'mandatory', itemKey),
            // format:'html along with argument sequence.'
            // format: ''
        });



        onCollectFormData({
            ...formData,
            consentMode: 'STORE',
            fetchType: 'PERIODIC',
            consentTypes: setValuesOfCheckBox(formValues.consentTypes, 'consentTypes', itemKey),

            nickName: formValues.nickName,
            dataTypes: setValuesOfCheckBox(formValues.dataTypes, 'dataTypes', itemKey),
            dataConsumer: setValuesOfSelectedBox(formValues.dataConsumer, 'dataConsumer', itemKey),
            dataProvider: formValues.dataProvider,
            purpose: setValuesOfCheckBox(formValues.purpose, 'purpose', itemKey),

            consentValidity: formValues.consentValidity,
            DataLife: { 'unit': 'YEAR', 'value': 1 },
            Frequency: { 'unit': 'YEAR', 'value': 1 },
            shared: setValuesOfCheckBox(formValues.shared, 'shared', itemKey),
            mandatory: setValuesOfCheckBox(formValues.mandatory, 'mandatory', itemKey),

        })
    }

    const setValuesOfSelectedBox = (values, key, count) => {
        // console.log('entityList-->'+JSON.stringify(entityList));
        var tempArr = [];
        for (let entity of entityList) {
            tempArr.push(entity.appName)
        }
        for (var consumerName of values) {
            if (!tempArr.includes(consumerName)) {
                var val = { "appName": consumerName, "clientId": "001" }
                //alert('In Here for val-->'+ JSON.stringify(val));
                entityList.push(val);
                setEntityListDraft(entityList);
            }
        }

    };

    const handleValidityChange = (e) => {
        const value = e.target.value;
        const numericValue = Number(value);

        // Constrain the value between 1 and 99
        if (!isNaN(numericValue)) {
            if (numericValue < 1) {
                handleInputChange({ target: { name: 'consentValidityValue', value: 1 } });
            } else if (numericValue > 99) {
                handleInputChange({ target: { name: 'consentValidityValue', value: 99 } });
            } else {
                handleInputChange(e);
            }
        }
    };

    return (
        <div className='row'>
            <div className='col-md-12'>
                <div className='ah-buttons'>
                    {/* Is Mandatory? */}
                    {/* <Switch 
                             name='mandatory'
                             id={`mandatory_${itemKey}`}
                             onClick={handleInputChange}
                            /> */}

                    <label class='consentBooleanCheckdown'><input type='checkbox'
                        name='mandatory'
                        class='consentTemplateCheckBox'
                        id={`mandatory_${itemKey}`}
                        onClick={handleInputChange} ></input> Mandatory?</label>
                </div>
                <Tabs
                    defaultActiveKey="dataType"
                    id="uncontrolled-tab-example"
                    className="custom-tabs mb-3"
                >
                    <Tab eventKey="dataType" title="Basic Details">
                        <div className='row align-items-center'>
                            <div className='col-md-5'>
                                <div class="card custom-cards dark no-shadow">
                                    <div class="card-body">
                                        <TextField fullWidth label="Enter Data Set Name" variant="standard" size='small'
                                            id="nickName" name="nickName"
                                            value={formData.nickName || ''}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-5'>
                                <div class="card custom-cards dark no-shadow">
                                    <div class="card-body">
                                        <TextField fullWidth
                                            label='Enter Data Fiduciary'
                                            value={formData.dataProvider || ''}
                                            variant="standard" size='small' name='dataProvider'
                                            id="dataFiduciaryText"
                                            onChange={handleInputChange}

                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-2'>
                                {/* <FormControlLabel
                                    control={<Checkbox checked={isChecked} onChange={handleCheckboxChange} />}
                                    name='shared'
                                    id={`shared_${itemKey}`}
                                    onClick={handleInputChange} 
                                    label="To be Shared"
                                    size="small"
                                /> */}
                                {/* onClick={handleInputChange}  */}
                                <label class='consentBooleanCheckdown'><input type='checkbox'
                                    name='shared'
                                    class='consentTemplateCheckBox'
                                    id={`shared_${itemKey}`}
                                    checked={isChecked}
                                    onChange={handleInputChange}
                                ></input> To Be Shared?</label>
                            </div>
                        </div>
                        {isChecked &&
                            <div className='row my-4'>
                                <div className='col-md-12'>
                                    {/* <div className='card custom-cards dark no-shadow'>
                                    <div className='card-body' style={showConsumerToggle ? { display: "block" } : { display: 'none' }}>
                                        <TextField
                                        fullWidth
                                        size='small'
                                        select
                                        label='Data Consumer'
                                        variant='standard'
                                        name='select1'
                                        value={values.select1}
                                        onChange={handleChange}
                                        >
                                        
                                        </TextField>
                                <select className="consentTemplateSelect" class="consentTemplateSelect"
                                id={`consumerId_${itemKey}`} multiple="multiple" name='dataConsumer'
                                required aria-label="select example"
                                onChange={handleInputChange}
                            >
                                {page !== "draft" && entityList && entityList.length !== 0 &&
                                    entityList.map((element, id) => {
                                        const isSelected = initialValues && initialValues.dataConsumer && initialValues.dataConsumer.includes(element.appName);
                                        return (<option key={element.clientId}
                                            value={element.appName} selected={isSelected ? 'selected' : ''}> {element.appName}  </option>)
                                    })}
                                {page == "draft" && entityListDraft && entityListDraft.length !== 0 &&
                                    entityListDraft.map((element, id) => {
                                        const isSelected = initialValues && initialValues.dataConsumer && initialValues.dataConsumer.includes(element.appName);
                                        return (<option key={element.clientId}
                                            value={element.appName} selected={isSelected ? 'selected' : ''}> {element.appName}  </option>)
                                    })}

                            </select>
                                    </div>
                                    </div> */}
                                    <div class="row consentTemplateDetail" >
                                        <div class="col-sm-2" style={showConsumerToggle ? { display: "block" } : { display: 'none' }}>
                                            <label class='consentTemplateLabel'>Data Consumer</label>
                                        </div>
                                        <div class="col-sm-10 dataConsumerStyle" style={showConsumerToggle ? { display: "block" } : { display: 'none' }}>
                                            <select class="consentTemplateSelect MuiInputBase-input MuiInput-input MuiInputBase-inputSizeSmall css-nz481w-MuiInputBase-input-MuiInput-input"
                                                id={`consumerId_${itemKey}`} multiple="multiple" name='dataConsumer'
                                                required aria-label="select example"
                                                onChange={handleInputChange}
                                                style={{ height: '100%', padding: '1%', width: 'fit-content' }}
                                            >
                                                {page !== "draft" && entityList && entityList.length !== 0 &&
                                                    entityList.map((element, id) => {
                                                        const isSelected = initialValues && initialValues.dataConsumer && initialValues.dataConsumer.includes(element.appName);
                                                        return (<option key={element.clientId}
                                                            value={element.appName} selected={isSelected ? 'selected' : ''}> {element.appName}  </option>)
                                                    })}
                                                {page == "draft" && entityListDraft && entityListDraft.length !== 0 &&
                                                    entityListDraft.map((element, id) => {
                                                        const isSelected = initialValues && initialValues.dataConsumer && initialValues.dataConsumer.includes(element.appName);
                                                        return (<option key={element.clientId}
                                                            value={element.appName} selected={isSelected ? 'selected' : ''}> {element.appName}  </option>)
                                                    })}

                                            </select>
                                            <label class='addNewLabel' onClick={() => {
                                                setShowAddConsumer(!showAddConsumer)
                                                // setuserVal({...userVal,format:dataVal})
                                            }} style={{ marginTop: '2%' }}><AddNewMaterialIcon /> Add New</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        <div className='row mt-4'>
                            {/* <div className='col-md-12 text-end'>
                                <button className='btn btn-outline-primary btn-r25 px-3 me-sm-3 mb-3 mb-sm-0'>
                                    <Icons.Save />
                                    Save as Draft
                                </button>
                                <button className='btn btn-primary btn-r25 px-3' onClick={addAccordionItem}>
                                    <Icons.Add />
                                    New Template
                                </button>
                                </div> */}
                        </div>
                    </Tab>

                    <Tab eventKey="dataItem" title="Data Type & Item">
                        <div className='row mt-4'>
                            <div className='col-md-12'>
                                <div class="card custom-cards cards-border no-shadow">

                                    <div class="card-body">
                                        <h6>Data Type</h6>
                                        <hr></hr>
                                        <div className='row align-items-center'>
                                            <div className='col-md-10' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>

                                                {getDatatypeList && getDatatypeList.length !== 0 && getDatatypeList.map((element, id) => {

                                                    return (
                                                        <li className='list-datatype-overwritten'>
                                                            {/* <FormControlLabel
                                                            control={<Checkbox />}
                                                            name='consentTypes'
                                                            value={element.dataType}
                                                            onChange={handleInputChange}
                                                            id={`${element.dataType}_${itemKey}`}
                                                            label={element.dataType}
                                                            size="small"
                                                          
                                                            /> */}

                                                            <label class='consentCheckboxLabel'><input type='checkbox'
                                                                name="consentTypes"
                                                                value={element.dataType}
                                                                onChange={handleInputChange}
                                                                id={`${element.dataType}_${itemKey}`}
                                                                class='consentTemplateCheckBox'></input> {element.dataType}</label>


                                                        </li>

                                                    )
                                                })}
                                            </div>
                                            <div className='col-md-2'>
                                                <button className='btn btn-primary btn-sm btn-r25 px-3' onClick={() => setOpenCreateDataType(true)}>
                                                    <Icons.Add />
                                                    Add New
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div class="card custom-cards cards-border no-shadow">
                                    <div class="card-body">
                                        <h6>Data Items</h6>
                                        <hr></hr>
                                        <div className='row'>
                                            <div className='col-md-6' >
                                                {option && option.length !== 0 ? (
                                                    option.map((element, id) => {
                                                        return (
                                                            <li className='list-datatype-overwritten'>
                                                                {/* <FormControlLabel
                                                control={<Checkbox />}
                                                name="dataTypes"
                                                value={element}
                                                onChange={handleInputChange}
                                                id={`${element}_${id}`}
                                                class='consentTemplateCheckBox'
                                                label={element}
                                                size="small"
                                                checked={Array.isArray(initialArray) &&
                                                    initialArray.includes(element)}
                                            /> */}

                                                                <label class='consentCheckboxLabel'><input type='checkbox'
                                                                    name="dataTypes"
                                                                    value={element}
                                                                    onChange={handleInputChange}
                                                                    id={`${element}_${id}`}
                                                                    class='consentTemplateCheckBox'
                                                                    checked={Array.isArray(initialArray) &&
                                                                        initialArray.includes(element)}
                                                                ></input> {element}</label>
                                                            </li>
                                                        )
                                                    })) : (
                                                    <p>Please Select a Data type to Populate the Data Items</p>
                                                )}

                                            </div>
                                            <div className='col-md-6'>
                                                <div class="card custom-cards dark no-shadow">
                                                    <div class="card-body">
                                                        <div className='check-list'>
                                                            {initialArray && initialArray.length !== 0 ? (
                                                                initialArray.map((element, id) => {
                                                                    return (

                                                                        <li>{element}</li>

                                                                    )
                                                                })) : (
                                                                <p>Nothing Selected</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mt-4'>

                        </div>
                    </Tab>

                    <Tab eventKey="purpose" title="Purpose">
                        <div className='row'>
                            <div className='col-md-12'>
                                <div class="card custom-cards cards-border no-shadow">
                                    <div class="card-body">
                                        <div className='row align-items-center'>
                                            <div className='col-md-10'>
                                                {getPurposeList && getPurposeList.length !== 0 &&
                                                    getPurposeList.map((element, id) => {
                                                        return (
                                                            <li className='list-datatype-overwritten'>
                                                                {/* <FormControlLabel
                                                    control={<Checkbox />}
                                                    name="purpose"
                                                    label={element.purpose}
                                                    value={element.purpose}
                                                    class='consentTemplateCheckBox'
                                                    onChange={handleInputChange}
                                                    id={`${element.purpose}_${itemKey}`}
                                                    size="small"
                                                /> */}

                                                                <label class='consentCheckboxLabel'>
                                                                    <input type='checkbox'
                                                                        name="purpose"
                                                                        value={element.purpose}
                                                                        onChange={handleInputChange}
                                                                        id={`${element.purpose}_${itemKey}`}
                                                                        class='consentTemplateCheckBox'></input>&nbsp;
                                                                    {element.purpose}</label>
                                                            </li>
                                                        )
                                                    })}
                                            </div>
                                            <div className='col-md-2 text-end'>
                                                <button className='btn btn-primary btn-sm btn-r25 px-3' onClick={() => setOpenCreatePurpose(true)}>
                                                    <Icons.Add />
                                                    Add New
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mt-4'>

                        </div>
                    </Tab>

                    <Tab eventKey="validity" title="Validity">
                        <div className='row'>
                            <div className='col-md-12'>
                                <div class="card custom-cards cards-border no-shadow">
                                    <div class="card-body">
                                        <div className='row align-items-center' style={{ height: '100px' }}
                                        >
                                            <div className='col-md-3' style={{ marginLeft: '10px', position: 'absolute' }}>
                                                <RadioGroup
                                                    row
                                                    defaultValue="MONTH"
                                                    name="consentValidityUnit"
                                                    id={`validityUnit_${itemKey}`}
                                                    onChange={handleInputChange}
                                                    value={formData.consentValidity.unit || ''}
                                                //style={{ padding: '15px' }}
                                                >
                                                    <FormControlLabel value="MONTH" control={<Radio />} label="Month" />
                                                    <FormControlLabel value="YEAR" control={<Radio />} label="Year" />
                                                </RadioGroup>
                                            </div>
                                            <div className='col-md-7' style={{ marginLeft: '200px', position: 'absolute', height: '0px', marginTop: '-21%' }}>
                                                <TextField
                                                    type='number'
                                                    fullWidth
                                                    variant="standard"
                                                    size='medium'
                                                    style={{ fontSize: '30px', margin: '30px' }}
                                                    id={`validityValue_${itemKey}`}
                                                    name="consentValidityValue"
                                                    onChange={handleInputChange}
                                                    value={formData.consentValidity.value || ''}
                                                    class='consentTemplateSelect'
                                                    inputProps={{
                                                        min: 1,
                                                        max: 99
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mt-4'>

                        </div>
                    </Tab>
                </Tabs>
            </div>

            <CreateData
                open={openCreateDataType}
                onClose={() => setOpenCreateDataType(false)}
            />

            <CreatePurpose
                open={openCreatePurpose}
                onClose={() => setOpenCreatePurpose(false)}
            />


            <Modal show={showAddConsumer} onHide={closeAddConsumerModal} backdrop="static" >
                <form className='needs-validation was-validated'>
                    <Modal.Header >
                        <Modal.Title>Add New Consumer</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <div className="row p-2 m-4 mt-0 mb-0">
                            <div className="tab-content" >
                                <div className="tab-pane fade show active"  >
                                    <div className="row register-form">
                                        <div className="form-group mb-1">
                                            <label className="mb-0 font-weight-bold">Data Consumer  : </label>
                                            <input type="text" className="form-control" placeholder="Enter Data Consumer" maxLength="200" required
                                                onChange={(event) => setConsumerName(event.target.value)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        {/* <MaterialButton variant="contained" color="primary"  onClick={handleClose}>Close</MaterialButton> */}
                        <button type="button" onClick={saveAddConsumer} className="btn btn-outline-primary btn-sm mt-3 mb-3" >Save</button>
                        <button type="button" onClick={closeAddConsumerModal} className="btn btn-danger btn-sm " style={{ borderRadius: '15px' }}>Close</button>
                    </Modal.Footer>
                </form>
            </Modal>

        </div>



    )
}

export default CreateConsentgroup;